import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ChallengeManagementService {
    constructor(private http: HttpClient) {}

    AUTH_SERVER_ADDRESS: string = environment.apiBaseUrl;
    CHALLENGES_PATH: string = environment.challengesPath;

    getAllChallenges(
        postPerPage?: number,
        currentPage?: number,
        filterObject?: object,
    ): Observable<any> {
        var userObjectString = $.param(filterObject);
        const queryParams = `?api=core&pageSize=${postPerPage}&currentPage=${currentPage}&${userObjectString}`;
        return this.http.get(this.AUTH_SERVER_ADDRESS + this.CHALLENGES_PATH + queryParams);
    }

    uploadChallengeSheet(formData: FormData): Observable<any> {
        return this.http.post(
            this.AUTH_SERVER_ADDRESS + this.CHALLENGES_PATH + '/upload',
            formData,
        );
    }

    previewChallengeFile(
        values: any,
        type: 'arraybuffer' | 'blob' | 'json' | 'text' = 'arraybuffer',
    ): Observable<any> {
        return this.http.get(
            `${this.AUTH_SERVER_ADDRESS + this.CHALLENGES_PATH}/preview?${$.param(values)}`,
            { responseType: type as 'arraybuffer' },
        );
    }

    createChallenge(challengeData: any): Observable<any> {
        return this.http.post<any>(this.AUTH_SERVER_ADDRESS + this.CHALLENGES_PATH, challengeData);
    }

    updateChallenge(id: string, challengeData: any): Observable<any> {
        return this.http.patch<any>(
            `${this.AUTH_SERVER_ADDRESS + this.CHALLENGES_PATH}/${id}`,
            challengeData,
        );
    }

    deleteChallenge(id: string): Observable<any> {
        return this.http.delete<any>(`${this.AUTH_SERVER_ADDRESS + this.CHALLENGES_PATH}/${id}`);
    }

    deleteChallengeSheet(filePath: any): Observable<any> {
        return this.http.post<any>(
            `${this.AUTH_SERVER_ADDRESS + this.CHALLENGES_PATH}/remove-file`,
            { filePath },
        );
    }
}
